// extracted by mini-css-extract-plugin
export var statItem = "_jt-1";
export var statsRow = "_jt-0";